<div class="col-12">
  <div class="row">
    <div class="property-form-group col-lg-6">
      <mat-accordion>
        <mat-expansion-panel [expanded]="!addressCollapsed">
          <mat-expansion-panel-header>
            <mat-panel-title>Adresse</mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="addressForm" (ngSubmit)="onSubmitAddress()">
            <div *ngIf="addressEdition; else addressStatic">
              <mat-form-field>
                <mat-label>Numéro et Rue</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  required
                  formControlName="street"
                />
                <mat-error>
                  <span *ngIf="fAddr('street').hasError('required')"
                    >Veuillez saisir une rue</span
                  >
                  <span *ngIf="fAddr('street').hasError('maxlength')"
                    >Le nom ne doit pas dépasser 50 caractères</span
                  >
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Complément</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  formControlName="complement"
                />
                <mat-error>
                  <span *ngIf="fAddr('complement').hasError('maxlength')"
                    >Le complément ne doit pas dépasser 50 caractères</span
                  >
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Code Postal</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  required
                  formControlName="postalCode"
                />
                <mat-error>
                  <span *ngIf="fAddr('postalCode').hasError('required')"
                    >Veuillez saisir un code postal</span
                  >
                  <span *ngIf="fAddr('postalCode').hasError('postalCode')"
                    >Format de code postal invalide</span
                  >
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Ville</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  required
                  formControlName="city"
                />
                <mat-error>
                  <span *ngIf="fAddr('city').hasError('required')"
                    >Veuillez saisir une ville</span
                  >
                  <span *ngIf="fAddr('city').hasError('maxlength')"
                    >La ville ne peut pas dépasser 50 caractères</span
                  >
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Pays</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  formControlName="country"
                />
                <mat-error>
                  <span *ngIf="fAddr('country').hasError('maxlength')"
                    >La pays ne peut pas dépasser 50 caractères</span
                  >
                </mat-error>
              </mat-form-field>
            </div>

            <ng-template #addressStatic>
              <div *ngIf="prop.address; else noAddress" class="text-center">
                <p>
                  <span>{{ prop.address.street }}</span>
                  <span *ngIf="prop.address.complement"
                    ><br />{{ prop.address.complement }}</span
                  >
                  <span
                    ><br />{{ prop.address.postalCode }}
                    {{ prop.address.city }}</span
                  >
                  <span *ngIf="prop.address.country"
                    ><br />{{ prop.address.country }}</span
                  >
                </p>
              </div>
            </ng-template>
            <ng-template #noAddress>
              <p class="text-center">Aucune adresse n'est configurée</p>
            </ng-template>
            <mat-action-row *ngIf="canUpdateProperty">
              <div *ngIf="addressEdition; else defaultAddressActions">
                <button
                  mat-mini-fab
                  color="primary"
                  appTooltip="Valider"
                  type="submit"
                >
                  <mat-icon aria-label="Valider">check</mat-icon>
                </button>
                <button
                  mat-mini-fab
                  color="primary"
                  type="button"
                  appTooltip="Annuler"
                  (click)="closeEditAddress()"
                >
                  <mat-icon aria-label="Annuler">close</mat-icon>
                </button>
              </div>
              <ng-template #defaultAddressActions>
                <div *ngIf="canUpdateAddress" class="mt-2">
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="editAddress()"
                    appTooltip="Modifier l'adresse"
                  >
                    <mat-icon aria-label="Modifier l'adresse">create</mat-icon>
                  </button>
                </div>
                <div *ngIf="prop.certified && !canUpdateAddress" class="mt-2">
                  <mat-icon
                    color="primary"
                    appTooltip="Ces informations ne sont pas modifiables car le bien est certifié"
                    >not_interested</mat-icon
                  >
                </div>
              </ng-template>
            </mat-action-row>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="property-form-group col-lg-6">
      <mat-accordion>
        <!-- COORDONNEES -->
        <mat-expansion-panel [expanded]="!locationCollapsed">
          <mat-expansion-panel-header>
            <mat-panel-title>Coordonnées</mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="locationForm" (ngSubmit)="onSubmitLocation()">
            <div *ngIf="locationEdition; else locationStatic">
              <mat-form-field>
                <mat-label>Latitude</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  required
                  formControlName="latitude"
                  decimalValue
                />
                <mat-error>
                  <span *ngIf="fLoc('latitude').hasError('required')"
                    >Veuillez saisir une latitude</span
                  >
                  <span *ngIf="fLoc('latitude').hasError('pattern')"
                    >La latitude doit être un nombre</span
                  >
                  <span *ngIf="fLoc('latitude').hasError('min')"
                    >La latitude ne peut pas être inférieure à -90</span
                  >
                  <span *ngIf="fLoc('latitude').hasError('max')"
                    >La latitude ne peut pas ête supérieure à 90</span
                  >
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Longitude</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  required
                  formControlName="longitude"
                  decimalValue
                />
                <mat-error>
                  <span *ngIf="fLoc('longitude').hasError('required')"
                    >Veuillez saisir une longitude</span
                  >
                  <span *ngIf="fLoc('longitude').hasError('pattern')"
                    >La longitude doit être un nombre</span
                  >
                  <span *ngIf="fLoc('longitude').hasError('min')"
                    >La longitude ne peut pas être inférieure à -180</span
                  >
                  <span *ngIf="fLoc('longitude').hasError('max')"
                    >La longitude ne peut pas ête supérieure à 180</span
                  >
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Altitude (m)</mat-label>
                <input
                  matInput
                  placeholder=""
                  type="text"
                  formControlName="altitude"
                  unit="m"
                  nullValue
                />
                <mat-error>
                  <span *ngIf="fLoc('altitude').hasError('required')"
                    >Veuillez saisir une altitude</span
                  >
                  <span *ngIf="fLoc('altitude').hasError('pattern')"
                    >L'altitude doit être un nombe entier</span
                  >
                  <span *ngIf="fLoc('altitude').hasError('min')"
                    >L'altitude ne peut pas être inférieure à 0</span
                  >
                </mat-error>
              </mat-form-field>
            </div>

            <ng-template #locationStatic>
              <div
                *ngIf="prop.location; else noLocation"
                class="property-field-group"
              >
                <div class="property-field-container col-12 col-md-6 col-xl-4">
                  <div class="property-field">
                    <span class="property-field-title">Latitude</span
                    ><span class="property-field-value">{{
                      prop.location.latitude | number : "1.0-6"
                    }}</span>
                  </div>
                </div>
                <div class="property-field-container col-12 col-md-6 col-xl-4">
                  <div class="property-field">
                    <span class="property-field-title">Longitude</span
                    ><span class="property-field-value">{{
                      prop.location.longitude | number : "1.0-6"
                    }}</span>
                  </div>
                </div>
                <div class="property-field-container col-12 col-md-6 col-xl-4">
                  <div class="property-field" *ngIf="prop.location.altitude">
                    <span class="property-field-title">Altitude</span
                    ><span class="property-field-value"
                      >{{ prop.location.altitude }} m</span
                    >
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template #noLocation>
              <p class="text-center">Aucune localisation n'est configurée</p>
            </ng-template>
            <mat-action-row *ngIf="canUpdateProperty">
              <div *ngIf="locationEdition; else defaultLocationActions">
                <button
                  mat-mini-fab
                  color="primary"
                  appTooltip="Valider"
                  type="submit"
                >
                  <mat-icon aria-label="Valider">check</mat-icon>
                </button>
                <button
                  mat-mini-fab
                  color="primary"
                  type="button"
                  appTooltip="Annuler"
                  (click)="closeEditLocation()"
                >
                  <mat-icon aria-label="Annuler">close</mat-icon>
                </button>
              </div>
              <ng-template #defaultLocationActions>
                <div
                  *ngIf="!prop.certified && prop.address && !prop.location"
                  class="mt-2 mr-1"
                >
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="confirmFindLocation()"
                    appTooltip="Récupérer la localisation à partir de l'adresse"
                  >
                    <mat-icon
                      aria-label="Récupérer la localisation à partir de l'adresse"
                      >location_searching</mat-icon
                    >
                  </button>
                </div>
                <div *ngIf="canUpdateLocation" class="mt-2">
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="editLocation()"
                    appTooltip="Modifier la localisation"
                  >
                    <mat-icon aria-label="Modifier la localisation"
                      >create</mat-icon
                    >
                  </button>
                </div>
                <div *ngIf="prop.certified && !canUpdateLocation" class="mt-2">
                  <mat-icon
                    color="primary"
                    appTooltip="Ces informations ne sont pas modifiables car le bien est certifié"
                    >not_interested</mat-icon
                  >
                </div>
              </ng-template>
            </mat-action-row>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="property-form-group">
      <mat-accordion>
        <!-- CADASTRE -->
        <mat-expansion-panel [expanded]="!landRegistryCollapsed">
          <mat-expansion-panel-header>
            <mat-panel-title>Cadastre</mat-panel-title>
          </mat-expansion-panel-header>
          <!-- form -->
          <form
            [formGroup]="landRegistryForm"
            (ngSubmit)="onSubmitLandRegistry()"
          >
            <div *ngIf="landRegistryEdition; else landRegistryStatic">
              <!-- MAIN LAND REGISTRY -->
              <div class="main-land-registry row">
                <app-input
                  [label]="'registry.plot'"
                  [formControl]="landRegistryForm.get('plot')"
                  [patternErrorLabel]="'registry.patternErrors.plot'"
                  [size]="1"
                ></app-input>
                <app-input
                  [label]="'registry.section'"
                  [formControl]="landRegistryForm.get('section')"
                  [patternErrorLabel]="'registry.patternErrors.section'"
                  [size]="1"
                ></app-input>
                <app-input
                  [label]="'registry.prefix'"
                  [formControl]="landRegistryForm.get('prefix')"
                  [patternErrorLabel]="'registry.patternErrors.prefix'"
                  [size]="1"
                ></app-input>
                <app-input
                  [label]="'registry.sheet'"
                  [formControl]="landRegistryForm.get('sheet')"
                  [patternErrorLabel]="'registry.patternErrors.sheet'"
                  [size]="1"
                ></app-input>
                <app-input
                  [label]="'registry.surface'"
                  [formControl]="landRegistryForm.get('surface')"
                  [size]="1"
                ></app-input>
                <app-input
                  [label]="'registry.codeInsee'"
                  [formControl]="landRegistryForm.get('inseeCode')"
                  [patternErrorLabel]="'registry.patternErrors.inseeCode'"
                  [size]="1"
                ></app-input>
                <app-input
                  [label]="'registry.urbanArea'"
                  [formControl]="landRegistryForm.get('urbanArea')"
                  [size]="1"
                ></app-input>
              </div>

              <!-- others registry -->
              <div [formGroup]="otherLandRegistriesForm">
                <div formArrayName="othersRegistries">
                  <p class="accordion-subtitle">Parcelles secondaires</p>
                  <div>
                    <button
                      type="button"
                      (click)="addOthersRegistries(null)"
                      appTooltip="Ajouter"
                      class="btn-add"
                    >
                      <mat-icon color="primary" aria-label="Ajouter"
                        >add_circle</mat-icon
                      >
                    </button>
                  </div>

                  <div
                    *ngFor="
                      let othersRegistries of othersRegistries.controls;
                      let i = index
                    "
                    class="row"
                  >
                    <app-input
                      [label]="'registry.plot'"
                      [formControl]="othersRegistries.get('plot')"
                      [patternErrorLabel]="'registry.patternErrors.plot'"
                      [size]="1"
                    ></app-input>
                    <app-input
                      [label]="'registry.section'"
                      [formControl]="othersRegistries.get('section')"
                      [patternErrorLabel]="'registry.patternErrors.section'"
                      [size]="1"
                    ></app-input>
                    <app-input
                      [label]="'registry.prefix'"
                      [formControl]="othersRegistries.get('prefix')"
                      [patternErrorLabel]="'registry.patternErrors.prefix'"
                      [size]="1"
                    ></app-input>
                    <app-input
                      [label]="'registry.sheet'"
                      [formControl]="othersRegistries.get('sheet')"
                      [patternErrorLabel]="'registry.patternErrors.sheet'"
                      [size]="1"
                    ></app-input>
                    <app-input
                      [label]="'registry.surface'"
                      [formControl]="othersRegistries.get('surface')"
                      [size]="1"
                    ></app-input>
                    <app-input
                      [label]="'registry.codeInsee'"
                      [formControl]="othersRegistries.get('inseeCode')"
                      [patternErrorLabel]="'registry.patternErrors.inseeCode'"
                      [size]="1"
                    ></app-input>

                    <button
                      (click)="removeOthersRegistries(i)"
                      appTooltip="Supprimer"
                      class="btn-remove"
                    >
                      <mat-icon color="primary" aria-label="Supprimer"
                        >delete_forever</mat-icon
                      >
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- CADASTRE CONTENU -->
            <ng-template #landRegistryStatic>
              <div *ngIf="prop.landRegistry; else noLandRegistry">
                <!-- MAIN LAND REGISTRY -->
                <div class="main-land-registry property-field-group">
                  <ng-container
                    *ngTemplateOutlet="
                      landRegistryContent;
                      context: { landRegistry: prop.landRegistry }
                    "
                  ></ng-container>
                </div>

                <!-- others registry -->
                <div *ngIf="prop.otherLandRegistries?.length > 0">
                  <p class="accordion-subtitle">Parcelles secondaires</p>
                  <div
                    *ngFor="let otherLandRegistry of prop.otherLandRegistries"
                    class="property-field-group item-of-list"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        landRegistryContent;
                        context: {
                          landRegistry: otherLandRegistry,
                          type: 'other'
                        }
                      "
                    ></ng-container>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template #noLandRegistry>
              <p class="text-center">
                Aucune information de cadastre n'est configurée
              </p>
            </ng-template>
            <!-- footer -->
            <mat-action-row *ngIf="canUpdateProperty">
              <div *ngIf="landRegistryEdition; else defaultLandRegistryActions">
                <button
                  mat-mini-fab
                  color="primary"
                  appTooltip="Valider"
                  type="submit"
                >
                  <mat-icon aria-label="Valider">check</mat-icon>
                </button>
                <button
                  mat-mini-fab
                  color="primary"
                  type="button"
                  appTooltip="Annuler"
                  (click)="closeEditLandRegistry()"
                >
                  <mat-icon aria-label="Annuler">close</mat-icon>
                </button>
              </div>
              <ng-template #defaultLandRegistryActions>
                <div *ngIf="canUpdateRegistry" class="mt-2">
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="editLandRegistry()"
                    appTooltip="Modifier la cadastre"
                  >
                    <mat-icon aria-label="Modifier la cadastre"
                      >create</mat-icon
                    >
                  </button>
                </div>
                <div *ngIf="prop.certified && !canUpdateRegistry" class="mt-2">
                  <mat-icon
                    color="primary"
                    appTooltip="Ces informations ne sont pas modifiables car le bien est certifié"
                    >not_interested</mat-icon
                  >
                </div>
              </ng-template>
            </mat-action-row>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<div class="col-12">
  <app-property-attributes-view
    [prop]="prop"
    [category]="category"
  ></app-property-attributes-view>
</div>

<div class="col-12 location">
  <mat-accordion>
    <mat-expansion-panel #mapPanel [expanded]="prop.location">
      <mat-expansion-panel-header>
        <mat-panel-title>Localisation</mat-panel-title>
      </mat-expansion-panel-header>
      <app-new-map
        *ngIf="prop.location; else noMap"
        [hasSatelliteView]="true"
        [hasPlanView]="true"
        [initZoom]="18"
        [hasCadastreView]="true"
        [hasVectorParcelles]="true"
        [hasEventParcelles]="false"
        [updateLocationEnabled]="this.locationEdition"
        [parcelleInputSelected]="parcelleSelected$"
        [props]="[prop]"
        (locationUpdated)="mapLocationUpdated($event)"
      >
      </app-new-map>
    </mat-expansion-panel>
  </mat-accordion>
</div>
<div class="col-12 docs">
  <app-property-doc-view
    [prop]="prop"
    [category]="category"
  ></app-property-doc-view>
</div>

<!-- LAND REGISTRY TEMPLATE -->
<ng-template
  #landRegistryContent
  let-landRegistry="landRegistry"
  let-type="type"
>
  <!-- identifiant -->
  <div
    *ngIf="landRegistry.identifierShort"
    class="property-field-container col-12 col-md-6 col-xl-4"
  >
    <div class="property-field">
      <span class="property-field-title">Parcelle</span>
      <span class="property-field-value">{{
        landRegistry.identifierShort
      }}</span>
    </div>
  </div>
  <div
    *ngIf="!landRegistry.identifierShort && landRegistry.plot"
    class="property-field-container col-12 col-md-6 col-xl-4"
  >
    <div class="property-field">
      <span class="property-field-title">Parcelle</span>
      <span class="property-field-value">{{ landRegistry.plot }}</span>
    </div>
  </div>
  <!-- sheet -->
  <div
    *ngIf="type !== 'other' && landRegistry.sheet"
    class="property-field-container col-12 col-md-6 col-xl-4"
  >
    <div class="property-field">
      <span class="property-field-title">Feuille</span>
      <span class="property-field-value">{{ landRegistry.sheet }}</span>
    </div>
  </div>
  <!-- surface -->
  <div
    *ngIf="landRegistry.surface"
    class="property-field-container col-12 col-md-6 col-xl-4"
  >
    <div class="property-field">
      <span class="property-field-title">Surface</span>
      <span class="property-field-value">{{ landRegistry.surface }} m²</span>
    </div>
  </div>
  <!-- inseeCode -->
  <div
    *ngIf="type !== 'other' && landRegistry.inseeCode"
    class="property-field-container col-12 col-md-6 col-xl-4"
  >
    <div class="property-field">
      <span class="property-field-title">Code Commune</span>
      <span class="property-field-value">{{ landRegistry.inseeCode }}</span>
    </div>
  </div>
  <!-- urban area -->
  <div
    *ngIf="type !== 'other' && landRegistry.urbanArea"
    class="property-field-container col-12 col-md-6 col-xl-4"
  >
    <div class="property-field">
      <span class="property-field-title"
        >Zone urbaine
        <mat-icon
          color="primary"
          *ngIf="landRegistry.urbanAreaText"
          [mdbPopover]="landRegistry.urbanAreaText"
          trigger="focus"
          tabindex="0"
          >info</mat-icon
        >
      </span>
      <span class="property-field-value">{{ landRegistry.urbanArea }}</span>
    </div>
  </div>
</ng-template>

<ng-template #noMap>
  <span class="no-content"
    >Veuillez renseigner votre localisation pour voir la carte</span
  >
</ng-template>
